import React, { useContext } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LanguageContext, { strings } from '../../contexts/language';

import hotel from '../../assets/images/hotel.jpg';

export default function Local() {
    const { language } = useContext(LanguageContext);
    const t = strings[language] || strings.pt;
    return (
        <div className="page"><Header />
            <main style={{ flex:1,padding:'40px 20px' }}>
                <div style={{ maxWidth:800,margin:'0 auto',textAlign:'center' }}>
                    <h2 className="section-title color_3">{t.local_title}</h2>
                    <div className="card-glass" style={{ borderRadius:16,padding:'36px',marginBottom:38 }}>
                        <h3 style={{ fontSize:22,fontWeight:800,color:'var(--color-dark)',marginBottom:8 }}>
                            Edifício Touring
                        </h3>
                        <p style={{ color:'var(--color-dark)',opacity:0.7,marginBottom:10 }}>
                            Praça Mauá - Saúde Rio de Janeiro - RJ
                        </p>
                    </div>
                    <div style={{ borderRadius:16,overflow:'hidden',marginTop:20 }}>
                        <img
                            src={hotel}
                            alt="Edifício Touring"
                            className="img-fluid"
                        />
                    </div>
                </div>
            </main>
        <Footer /></div>
    );
}
